var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-header"},[_c('div',{staticClass:"top"},[_vm._m(0),_c('div',[_c('div',{class:{
          time: true,
          show: _vm.time.show,
          warning: _vm.time.warning
        }},[_c('i',{staticClass:"iconfont icon-time"}),_c('span',[_vm._v("Time Remaining "+_vm._s(_vm._f("timeLen")((_vm.time.current * 1000))))])]),(_vm.currentStepCount > -1)?_c('div',{staticClass:"step"},[_c('i',{staticClass:"iconfont icon-menu"}),_c('span',[_vm._v(_vm._s(_vm.currentStepCount + 1)+" of "+_vm._s(_vm.examRealList.length))])]):_vm._e()])]),_c('div',{staticClass:"top-bar"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo-home.png")}})])
}]

export { render, staticRenderFns }